module.exports = __webpack_public_path__ + "static/media/temp-perfil-1.d7a375ae.jpg";